import { ActionTree } from 'vuex';
import {
  ECreateEditorAction,
  ECreateEditorMutation,
  state as defaultState,
} from './create-editor.constants';
import { ICreateEditorState } from './create-editor.types';
import { EditorBlockService } from '@/editor/api/services/editor-block.service';
import { RootState } from '@/store/store';

export const actions: ActionTree<ICreateEditorState, RootState> = {
  async [ECreateEditorAction.Create]({ dispatch }) {
    try {
      const { id }: { id: string } = await EditorBlockService.createEditorBlock();
      dispatch(ECreateEditorAction.CreateSuccess, id);
    } catch {
      dispatch(ECreateEditorAction.CreateFailed);
    }
  },
  [ECreateEditorAction.CreateSuccess]({ commit }, id: string) {
    commit(ECreateEditorMutation.SetCreatedEditorId, id);
  },
  [ECreateEditorAction.CreateFailed]({ commit }) {
    commit(ECreateEditorMutation.SetCreatedEditorId, null);
  },
  [ECreateEditorAction.Reset]({ commit }) {
    commit(ECreateEditorMutation.SetState, { ...defaultState });
  },
};
